import {createAsync, RouteDefinition} from "@solidjs/router";
import {For, Show, Suspense} from "solid-js"
import {getInvoices} from "~/api/invoices";
import {getSubscription} from "~/api/subscriptions";
import Page from "~/components/Page";
import Container from "~/components/Container";
import Section from "~/components/Section";

export const route = {
    preload: async () => {
        await Promise.all([
            getInvoices(),
            getSubscription()
        ])
    }
} satisfies RouteDefinition
export default function BillingPage() {

    const invoices = createAsync(() => getInvoices())
    const subscription = createAsync(() => getSubscription())

    return (
        <Page>
            <Container>
                <h1>Billing</h1>
            </Container>
            <Section>
                <Container>
                    <h2>Active Subscription</h2>
                    <Suspense fallback={<p>Loading Subscription</p>}>
                        <Show when={subscription()} keyed fallback={<p>You have no active subscription</p>}>
                            {subscription => (
                                <div>
                                    <p>Plan: Premium</p>
                                    <p>Status: {subscription.status}</p>
                                    <p>Next Payment: {subscription.current_period_end}</p>
                                </div>
                            )}
                        </Show>
                    </Suspense>
                </Container>
            </Section>
            <Section>
                <Container>
                    <h2>Invoices</h2>
                    <Suspense fallback={<p>Loading Invoices</p>}>
                        <Show when={invoices()} keyed fallback={<p>You have no previous invoices</p>}>
                            {invoices => (
                                <table>
                                    <thead>
                                    <tr>
                                        <th>ID</th>
                                        <th>Title</th>
                                        <th>Date</th>
                                        <th>Amount</th>
                                        <th>Status</th>
                                        <th></th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                    <For each={invoices}>
                                        {invoice => (
                                            <tr>
                                                <td>{invoice.id}</td>
                                                <td>{invoice.title}</td>
                                                <td>{new Date(invoice.invoice_date).toLocaleDateString()}</td>
                                                <td>{(invoice.amount / 100).toLocaleString('en-GB', {
                                                    style: 'currency',
                                                    currency: invoice.currency.toUpperCase()
                                                })}</td>
                                                <td>{invoice.status}</td>
                                                <td><a href={`/dashboard/billing/invoice/${invoice.id}`}>View</a></td>
                                            </tr>
                                        )}
                                    </For>
                                    </tbody>
                                </table>
                            )}
                        </Show>
                    </Suspense>
                </Container>
            </Section>
        </Page>
    )
}
